import { Github, Mail, type LucideIcon } from "lucide-react"
import { XIcon } from "@/components/XIcon"

// ============================================================================
// Types
// ============================================================================

/** Social link configuration */
interface SocialLink {
  readonly name: string
  readonly url: string
  readonly icon: LucideIcon
  readonly isExternal: boolean
}

/** Personal info configuration */
interface PersonalInfo {
  readonly name: string
  readonly email: string
  readonly tagline: string
  readonly location: string
  /** IANA time zone for `location`; drives the footer clock and BitBoy's moods */
  readonly timeZone: string
  /** Latitude and longitude of `location` (degrees); drives the top sky and the day/night theme */
  readonly coordinates: { readonly lat: number; readonly lon: number }
  readonly updatedDate: string
  readonly bio: readonly string[]
}

// ============================================================================
// Configuration
// ============================================================================

/** Personal information displayed throughout the site */
export const personalInfo = {
  name: "Nalongkorn Panti",
  email: "nalongkon1996@gmail.com",
  tagline: "Building things that solve real problems.",
  location: "Bangkok, Thailand",
  timeZone: "Asia/Bangkok",
  coordinates: { lat: 13.7563, lon: 100.5018 },
  updatedDate: "Apr 13, 2026",
  bio: [
    "I’m a software engineer based in Bangkok, Thailand. I mostly work on backend — TypeScript and Rust.",
    "I like solving practical problems and keeping things simple. Always learning, always shipping.",
  ],
} as const satisfies PersonalInfo

/** Social media links for contact section */
export const socialLinks: readonly SocialLink[] = [
  {
    name: "GitHub",
    url: "https://github.com/Justar96",
    icon: Github,
    isExternal: true,
  },
  {
    name: "X",
    url: "https://x.com/bebe_tar24",
    icon: XIcon,
    isExternal: true,
  },
  {
    name: "Email",
    url: "mailto:nalongkon1996@gmail.com",
    icon: Mail,
    isExternal: false,
  },
] as const
